import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import classNames from 'classnames';
import s from './index.less';
import { Icon } from '@/components';
import rootStore from '@/models';

interface Props {
  title?: string;
  content?: string;
  visible?: boolean;
  isMobile?: boolean;
}

const Tip: React.FC<Props> = observer(props => {
  const { title, content, visible: propVisible, isMobile } = props;
  const [visible, setVisible] = useState<boolean>(true);
  useEffect(() => {
    // 简单的受控组件可以这样定义,复杂的还是要先判断下是否受控
    // 只要关闭了 当前就不会在开启 这是设计定的逻辑
    if (!propVisible) {
      setVisible(!!propVisible);
    }
  }, [propVisible]);
  return visible ? (
    <div
      className={classNames(classNames(s.tip, { [s.h5]: isMobile, [s.hidden]: !rootStore.common.isGroupInterview }))}
      onClick={e => {
        e.stopPropagation();
      }}
    >
      <Icon
        className={s.tipIcon}
        name="icon-close_nor"
        size={20}
        onClick={() => {
          setVisible(false);
        }}
      />
      <i className={s.arrow} />
      <div className={s.title}>{title}</div>
      {content}
    </div>
  ) : null;
});
export default Tip;
